import { useEffect, useState } from "react";
import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";

export default function PlanDialog({
  open,
  onClose,
  activePlan,
  membershipsForUser,
  onConfirm,
}) {
  const [billingOption, setBillingOption] = useState("monthly");

  useEffect(() => {
    if (open) {
      setBillingOption("monthly");
    }
  }, [open, activePlan]);

  const selectedPrice = activePlan
    ? membershipsForUser[`${activePlan}${billingOption === "yearly" ? "Yearly" : ""}`]?.price
    : null;

  const handleConfirm = () => {
    if (!activePlan) return;
    const membershipKey = `${activePlan}${billingOption === "yearly" ? "Yearly" : ""}`;
    onConfirm(membershipKey);
  };

  return (
    <Dialog open={open} onClose={onClose} className="relative z-[99999]">
      <DialogBackdrop className="fixed inset-0 bg-[#000] backdrop-blur-sm bg-opacity-75 transition-opacity" />

      <div className="fixed inset-0 flex items-center justify-center p-4 sm:p-6">
        <DialogPanel className="relative w-full max-w-md overflow-hidden rounded-[14px] border border-white/10 bg-[#141414] p-6 text-white shadow-xl backdrop-blur-sm transition-all">
          <button
            type="button"
            onClick={onClose}
            className="absolute right-4 top-4 text-white/70 transition hover:text-white"
          >
            <img src="/assets/icons/icon-close.svg" alt="Close" className="h-4 w-4 invert" />
          </button>

          <div className="space-y-3">
            <Dialog.Title className="text-2xl font-semibold text-white">
              Choose billing for {activePlan || "Plan"}
            </Dialog.Title>
            <Dialog.Description className="text-sm text-slate-400">
              Choose monthly or yearly billing before continuing to checkout.
            </Dialog.Description>
          </div>

          <div className="mt-6 space-y-4">
            <fieldset className="space-y-3">
              <legend className="text-sm font-medium text-slate-300">Billing interval</legend>
              <label className="group flex items-center gap-3 rounded-2xl border border-white/10 bg-white/5 px-4 py-4 transition hover:border-primary">
                <input
                  type="radio"
                  name="billingOption"
                  value="monthly"
                  checked={billingOption === "monthly"}
                  onChange={() => setBillingOption("monthly")}
                  className="sr-only peer"
                />
                <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-white/20 transition-all duration-200 peer-checked:border-primary peer-checked:bg-primary">
                  <span className="h-2.5 w-2.5 rounded-full bg-transparent transition-all duration-200 peer-checked:bg-white" />
                </span>
                <div>
                  <p className="font-semibold text-white">Monthly</p>
                  <p className="text-sm text-slate-400">${membershipsForUser[activePlan]?.price}/month</p>
                </div>
              </label>
              <label className="group flex items-center gap-3 rounded-2xl border border-white/10 bg-white/5 px-4 py-4 transition hover:border-primary">
                <input
                  type="radio"
                  name="billingOption"
                  value="yearly"
                  checked={billingOption === "yearly"}
                  onChange={() => setBillingOption("yearly")}
                  className="sr-only peer"
                />
                <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-white/20 transition-all duration-200 peer-checked:border-primary peer-checked:bg-primary">
                  <span className="h-2.5 w-2.5 rounded-full bg-transparent transition-all duration-200 peer-checked:bg-white" />
                </span>
                <div>
                  <p className="font-semibold text-white">Yearly</p>
                  <p className="text-sm text-slate-400">${membershipsForUser[`${activePlan}Yearly`]?.price}/year</p>
                </div>
              </label>
            </fieldset>
          </div>

          <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-end">
            <button
              type="button"
              className="inline-flex justify-center rounded-xl border border-white/10 bg-white/5 px-4 py-2 text-sm font-medium text-white transition hover:border-primary hover:bg-white/10"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="button"
              className="inline-flex justify-center rounded-xl bg-primary px-4 py-2 text-sm font-semibold transition hover:bg-primary/90"
              onClick={handleConfirm}
            >
              Continue to Checkout{selectedPrice ? `   $${selectedPrice}` : ""}
            </button>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
